import React, { useState, useCallback } from 'react';
import { TouchableOpacity, Text, StyleSheet } from 'react-native-web';

const Button = ({ onPress, text, variant = 'primary', style, disabled = false }) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = useCallback(() => {
        if (!disabled) setIsHovered(true);
    }, [disabled]);
    const handleMouseLeave = useCallback(() => setIsHovered(false), []);

    const handlePress = useCallback(() => {
        if (!disabled && onPress) {
            onPress();
        }
    }, [disabled, onPress]);

    const getStyles = () => {
        switch (variant) {
            case 'secondary':
                return {
                    button: styles.greyBtn,
                    buttonHovered: styles.greyBtnHovered,
                    buttonDisabled: styles.greyBtnDisabled,
                    text: styles.greyBtnText,
                    textDisabled: styles.greyBtnTextDisabled
                };
            case 'tertiary':
                return {
                    button: styles.lightBlueBtn,
                    buttonHovered: styles.lightBlueBtnHovered,
                    buttonDisabled: styles.lightBlueBtnDisabled,
                    text: styles.lightBlueBtnText,
                    textDisabled: styles.lightBlueBtnTextDisabled
                };
            case 'warning':
                return {
                    button: styles.redBtn,
                    buttonHovered: styles.redBtnHovered,
                    buttonDisabled: styles.redBtnDisabled,
                    text: styles.redBtnText,
                    textDisabled: styles.redBtnTextDisabled
                };
            default:
                return {
                    button: styles.blueBtn,
                    buttonHovered: styles.blueBtnHovered,
                    buttonDisabled: styles.blueBtnDisabled,
                    text: styles.blueBtnText,
                    textDisabled: styles.blueBtnTextDisabled
                };
        }
    };

    const { button, buttonHovered, buttonDisabled, text: textStyle, textDisabled } = getStyles();

    return (
        <TouchableOpacity 
            style={[
                button, 
                !disabled && isHovered && buttonHovered, 
                disabled && buttonDisabled,
                style
            ]}
            onPress={handlePress}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            disabled={disabled}
        >
            <Text style={[textStyle, disabled && textDisabled]}>{text}</Text>
        </TouchableOpacity>
    );
};

const styles = StyleSheet.create({
    blueBtn: {
        backgroundColor: '#396de0',
        borderRadius: 25,
        padding: 10,
        alignItems: 'center',
        justifyContent: 'center',
        width: 150,
        transition: 'background-color 0.3s ease',
    },
    blueBtnHovered: {
        backgroundColor: '#2a51a8',
    },
    blueBtnText: {
        color: 'white',
        fontFamily: "'lato', sans-serif",
        fontWeight: 'bold',
    },
    blueBtnDisabled: {
        backgroundColor: '#a8c4e8',
        opacity: 0.6,
    },
    blueBtnTextDisabled: {
        color: '#e8e8e8',
    },
    greyBtn: {
        backgroundColor: '#f0f0f0',
        borderRadius: 25,
        padding: 10,
        alignItems: 'center',
        justifyContent: 'center',
        width: 150,
        transition: 'background-color 0.3s ease',
    },
    greyBtnHovered: {
        backgroundColor: '#e0e0e0',
    },
    greyBtnText: {
        color: '#737373',
        fontFamily: "'lato', sans-serif",
        fontWeight: 'bold',
    },
    greyBtnDisabled: {
        backgroundColor: '#f8f8f8',
        opacity: 0.6,
    },
    greyBtnTextDisabled: {
        color: '#b8b8b8',
    },
    lightBlueBtn: {
        backgroundColor: '#e6f2ff',
        borderRadius: 25,
        padding: 10,
        alignItems: 'center',
        justifyContent: 'center',
        width: 150,
        transition: 'background-color 0.3s ease',
    },
    lightBlueBtnHovered: {
        backgroundColor: '#d1e6ff',
    },
    lightBlueBtnText: {
        color: '#396de0',
        fontFamily: "'lato', sans-serif",
        fontWeight: 'bold',
    },
    lightBlueBtnDisabled: {
        backgroundColor: '#f5f9ff',
        opacity: 0.6,
    },
    lightBlueBtnTextDisabled: {
        color: '#a8c4e8',
    },
    redBtn: {
        backgroundColor: '#e03939',
        borderRadius: 25,
        padding: 10,
        alignItems: 'center',
        justifyContent: 'center',
        width: 150,
        transition: 'background-color 0.3s ease',
    },
    redBtnHovered: {
        backgroundColor: '#e8b5b5',
    },
    redBtnText: {
        color: 'white',
        fontFamily: "'lato', sans-serif",
        fontWeight: 'bold',
    },
    redBtnDisabled: {
        backgroundColor: '#f0b8b8',
        opacity: 0.6,
    },
    redBtnTextDisabled: {
        color: '#f8e8e8',
    },
});

export default Button;